/* Cart drawer script for the heirloom-edition product page only (loaded as a module from snippets/cart-drawer.liquid: Shopify's asset pipeline
   rewrites import() inside classic scripts, so the events module is imported statically through the theme's import map).
   1) Cross-sell row "Топ вибір для вашого кошика": products come from the same source as the "Вам також сподобається" section (the section
      renderer endpoint /recommendations/products?intent=related for the current product), products already in the cart are left out, and the
      "+" button adds the selected variant with the theme's own add-to-cart pipeline: a CartLinesUpdateEvent with a promise is dispatched from the
      button, /cart/add.js is called with sections=cart-drawer-section, and the promise is resolved with the rendered section, so
      cart-items-component morphs the drawer exactly as it does for the product form (the drawer stays open, the new line appears at the top).
      The row lives in a [data-skip-subtree-update] node, so the morph keeps it between renders; if the whole drawer content is replaced (empty
      -> filled) the observer below fills the new node again.
   2) Two strings that are attributes / come from another snippet and so cannot use the two-language spans: the promo-code input placeholder and the
      "Continue shopping" button of the empty cart. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

(function () {
  var main = document.getElementById('MainContent');
  if (!main || main.dataset.template !== 'product.heirloom-edition') return;

  var SECTION_ID = 'cart-drawer-section';
  var MAX_CARDS = 8;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
  var formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency });
  var recsPromise = null;

  function money(cents) {
    return formatter.format(cents / 100);
  }

  function esc(text) {
    var d = document.createElement('div');
    d.textContent = text == null ? '' : String(text);
    return d.innerHTML;
  }

  function currentProductId() {
    var rec = document.querySelector('product-recommendations[data-product-id]');
    if (rec) return rec.getAttribute('data-product-id');
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    return meta ? String(meta.id) : null;
  }

  /* Same source as the "Вам також сподобається" section: its rendered cards, in the same order. */
  function loadRecommendations() {
    if (recsPromise) return recsPromise;
    var rec = document.querySelector('product-recommendations[data-section-id]');
    var productId = currentProductId();
    if (!rec || !productId) return (recsPromise = Promise.resolve([]));
    var url = '/recommendations/products?section_id=' + encodeURIComponent(rec.getAttribute('data-section-id')) +
      '&product_id=' + encodeURIComponent(productId) + '&limit=' + MAX_CARDS + '&intent=' + encodeURIComponent(rec.getAttribute('data-intent') || 'related');
    recsPromise = fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var handles = [];
        doc.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
        });
        return Promise.all(handles.slice(0, MAX_CARDS).map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
        }));
      })
      .then(function (list) { return list.filter(Boolean); })
      .catch(function () { return []; });
    return recsPromise;
  }

  function cardHtml(p) {
    var variants = p.variants || [];
    var available = variants.filter(function (v) { return v.available; });
    var chosen = available[0] || variants[0];
    var soldOut = !available.length;
    var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
    var opts = '';
    if (available.length > 1) {
      opts = '<div class="cy-card__opts" role="group" aria-label="Варіант">' + available.map(function (v, i) {
        return '<button type="button" class="cy-card__opt" data-variant="' + v.id + '" aria-pressed="' + (i === 0) + '">' + esc(v.title) + '</button>';
      }).join('') + '</div>';
    }
    var add = soldOut ? '' :
      '<button type="button" class="cy-card__add" aria-label="Додати в кошик: ' + esc(p.title) + '" data-product="' + p.id + '"></button>';
    return '<article class="cy-card" data-product="' + p.id + '" data-variant="' + esc(chosen ? chosen.id : '') + '">' +
      '<a class="cy-card__link" href="' + esc(p.url.split('?')[0]) + '">' +
        '<span class="cy-card__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        (soldOut ? '<span class="cy-card__badge">Sold out</span>' : '') + '</span>' +
        '<span class="cy-card__title">' + esc(p.title) + '</span>' +
      '</a>' + opts +
      '<div class="cy-card__foot"><span class="cy-card__price">' + money(chosen ? chosen.price : p.price) + '</span>' + add + '</div>' +
    '</article>';
  }

  function fillCross() {
    var cross = document.querySelector('#cart-drawer [data-cy-cross]');
    var row = cross && cross.querySelector('[data-cy-cross-row]');
    if (!row) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var signature = inCart.join(',');
      if (row.dataset.cySig === signature && row.children.length) return;
      return loadRecommendations().then(function (list) {
        var shown = list.filter(function (p) { return inCart.indexOf(p.id) === -1; });
        row.dataset.cySig = signature;
        row.innerHTML = shown.map(cardHtml).join('');
      });
    }).catch(function () {});
  }

  function localize() {
    document.querySelectorAll('#cart-drawer .cart-discount__input').forEach(function (input) {
      if (input.placeholder !== 'Промокод') input.placeholder = 'Промокод';
    });
    document.querySelectorAll('#cart-drawer .cart-items__empty-button .button-text').forEach(function (el) {
      if (el.textContent.trim() !== 'Продовжити покупки') el.textContent = 'Продовжити покупки';
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { localize(); fillCross(); }, 60);
  }

  function post(variantId) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', Theme.routes.cart_add_url);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); }
      };
      x.onerror = function () { reject(new Error('network')); };
      x.send(JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: SECTION_ID,
        sections_url: window.location.pathname
      }));
    });
  }

  function addToCart(button, variantId, productId) {
    if (button.hasAttribute('data-loading')) return;
    button.setAttribute('data-loading', 'true');
    var started = Date.now();
    var done = function () {
      setTimeout(function () { button.removeAttribute('data-loading'); }, Math.max(0, 400 - (Date.now() - started)));
    };

    var deferred = CartLinesUpdateEvent.createPromise();
    button.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise
    }));

    post(variantId).then(function (response) {
      return fetch(Theme.routes.cart_url + '.json').then(function (r) { return r.json(); }).then(function (ajaxCart) {
        var failed = Boolean(response.status);
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: {
            items: ajaxCart.items,
            source: 'cy-cross-sell',
            sourceId: 'cy-cross-sell',
            itemCount: 1,
            productId: String(productId),
            sections: failed ? undefined : response.sections,
            didError: failed
          }
        });
        if (failed) {
          button.title = response.description || response.message || 'Не вдалося додати товар';
        } else {
          var scroller = document.querySelector('#cart-drawer .cy-cart-scroll');
          if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }).catch(function (error) {
      deferred.reject(error);
      console.warn('[chuyou-cart] add failed', error);
    }).then(done, done);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opt = target.closest('#cart-drawer .cy-card__opt');
    if (opt) {
      var card = opt.closest('.cy-card');
      card.dataset.variant = opt.dataset.variant;
      card.querySelectorAll('.cy-card__opt').forEach(function (o) { o.setAttribute('aria-pressed', String(o === opt)); });
      return;
    }

    var add = target.closest('#cart-drawer .cy-card__add');
    if (add) {
      var cardEl = add.closest('.cy-card');
      addToCart(add, cardEl.dataset.variant, cardEl.dataset.product);
    }
  });

  function start() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        return !(r.target instanceof Element && r.target.closest('[data-cy-cross]'));
      });
      if (relevant) schedule();
    }).observe(drawer, { childList: true, subtree: true });
    document.addEventListener(StandardEvents.cartLinesUpdate, schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
